export default __webpack_public_path__ + "static/media/Facebook.6c83ee5c.png";